import { render, staticRenderFns } from "./IndustryRisk.vue?vue&type=template&id=52000268"
import script from "./IndustryRisk.vue?vue&type=script&lang=js"
export * from "./IndustryRisk.vue?vue&type=script&lang=js"
import style0 from "./IndustryRisk.vue?vue&type=style&index=0&id=52000268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports